module.exports = __webpack_public_path__ + "static/media/do.b7ac95ee.svg";